<template>
    <v-layout wrap>
        <v-flex xs12 sm12 md12 lg12 xl12>
            <div v-if="showList">


                <!--div style="text-align: center;padding: 10px;background-color: #c3c3c3;color: white">
                    Gửi mã lớp học cho thành viên, hoặc thêm thành viên trực tiếp tại đây
                </div-->
                <div id="divTeachers" style="...">
                    <!--v-dialog max-width="600px" v-model="tDialog">
                        <v-btn
                                small
                                fab
                                class="mb-2"
                                color="orange"
                                dark
                                slot="activator"
                                title="Thêm giáo viên"
                        >
                            <v-icon>add</v-icon>
                        </v-btn>
                        <v-card>
                            <v-card-title>
                                <span class="headline">Mời giáo viên</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xm12 md12 sm12 lg12 xs12>
                                            <v-form ref="teacherForm" v-model="teacherForm">
                                                <v-text-field
                                                        name="tEmails"
                                                        v-validate="'required|multiEmail'"
                                                        label="Nhập email của giáo viên bạn muốn mời vào lớp học"
                                                        :error-messages="errors.first('tEmails')"
                                                        data-vv-as="Email"
                                                        append-icon="email"
                                                        @keypress="searchTeacher"
                                                        v-model="tEmails"
                                                ></v-text-field>
                                            </v-form>
                                            <v-data-table :headers="teacherHeaders" :items="teacherBySearch"
                                                          class="elevation-1" hide-actions>
                                                <template slot="items" slot-scope="props">
                                                    <td class="text-xs-left">{{ props.item.fullName }}</td>
                                                    <td class="text-xs-left">{{ props.item.email }}</td>
                                                    <td class="justify-center layout px-0">
                                                        <v-btn @click="selectTeacher(props.item.email)"
                                                               class="mx-0" icon>
                                                            <v-icon color="pink">note_add</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </template>
                                            </v-data-table>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click.native="tClose" color="red" dark>Hủy</v-btn>
                                <v-btn @click.native="inviteTeacher" class="yoprimary" dark>Mời</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog-->
                    <div class="tableHeader">Giảng viên</div>
                    <v-data-table :headers="teacherHeaders" :items="teachers" class="elevation-1" hide-actions>
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-left">{{ props.item.fullName }}</td>
                            <td class="text-xs-left">{{ props.item.email }}</td>
                            <td class="text-xs-left">{{ props.item.phone }}</td>
                            <td class="justify-center layout px-0"
                                v-if="$store.state.auth.user.role == 4|| $store.state.auth.user.role == 1">
                                <v-btn @click="viewMember(props.item,'teacher')" class="mx-0" icon>
                                    <v-icon color="primary">visibility</v-icon>
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>
                </div>
                <div id="divStudents" style="text-align: right;margin-top: 10px">
                    <v-btn small class="yoprimary" dark title="Thêm học viên" @click="addNewStudent"
                           v-if="$store.state.auth.user.role==1 || $store.state.auth.user.role==4">
                        <v-icon>add</v-icon>
                        Thêm học viên
                    </v-btn>
                    <v-btn small class="yoprimary" color="primary" dark @click="onApprove"
                           v-if="$store.state.auth.user.role==1 || $store.state.auth.user.role==4">
                        <v-icon>verified_user</v-icon>
                        Duyệt học viên vào lớp
                    </v-btn>
                    <v-dialog max-width="600px" v-model="cDialog" persistent>
                        <v-card>
                            <v-card-title>
                                <div class="headline dialog-header">
                                    <v-btn @click="cDialog=false" icon style="float: left">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                    THÊM HỌC VIÊN
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <div style="width: 48%" class="yobox">
                                            <div class="step_number">1</div>
                                            <div style="font-weight: bold">Bạn đã có danh sách học viên của lớp
                                                học này
                                            </div>
                                            <div style="font-style: italic">Thêm học viên đã đăng ký vào danh
                                                sách lớp của bạn tại Yoclass
                                            </div>
                                            <br/>
                                            <v-btn dark class="yoprimary" @click="insertNewStudent">Thêm Học viên
                                                vào danh sách
                                            </v-btn>
                                        </div>
                                        <div style="width: 48%" class="yobox">
                                            <div class="step_number">2</div>
                                            <div style="font-weight: bold">Bạn muốn tuyển sinh thêm học viên cho
                                                lớp của mình
                                            </div>
                                            <div style="font-style: italic">Gửi cho các học viên tiềm năng lời
                                                mời & mã Lớp học này để học viên đăng ký
                                            </div>
                                            <v-btn dark class="yoprimary" @click="sDialog=true">Gửi lời mời cho
                                                Học viên mới
                                            </v-btn>
                                        </div>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                    <v-dialog max-width="600px" v-model="sDialog" persistent>
                        <v-card>
                            <v-card-title>
                                <div class="headline dialog-header">
                                    <v-btn @click="sDialog=false" icon style="float: left">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                    <span>Mời học viên</span>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xm12 md12 sm12 lg12 xs12>
                                            <div>Gủi link và mã lớp học để mời các học viên tiền năng tham gia
                                                lớp học của bạn
                                            </div>
                                            <label>- Lớp: </label><label v-if="cl != null"
                                                                         style="font-weight: bold; font-size: 20px">
                                            {{cl.className}}</label>
                                            <br/>
                                            <label>- Mã lớp: </label><label v-if="cl != null"
                                                                            style="font-weight: bold; font-size: 20px">
                                            {{cl.classCode}}</label>
                                            <br/>
                                            <label>Chia sẻ Mã lớp học để Học viên gửi yêu cầu tham gia lớp học
                                                trên https://yoclass.vn và chờ bạn phê duyệt.</label>
                                            <v-btn flat dark class="yoprimary" @click="copyCode">Copy lời mời
                                            </v-btn>
                                            <br/>
                                            <label>Hoặc gửi lời mời tham gia lớp tới email của học viên</label>
                                            <v-btn flat dark class="yoprimary" @click="showInvite = true"
                                                   v-if="!showInvite">Gửi lời mời qua email
                                            </v-btn>
                                            <div v-if="showInvite">
                                                <v-form v-model="studentForm"
                                                        @keypress.enter.native.prevent="addInviteStudent">
                                                    <v-text-field
                                                            name="sEmails"
                                                            v-validate="'required|multiEmail'"
                                                            label="Nhập email học viên bạn muốn mời vào lớp học"
                                                            data-vv-as="Email"
                                                            :error-messages="errors.first('sEmails')"
                                                            append-icon="email"
                                                            @app
                                                            v-model="sEmails"
                                                            @click:append="addInviteStudent"
                                                    ></v-text-field>
                                                </v-form>
                                                <!--div class="tableHeader">Danh sách học viên gợi ý</div-->
                                                <!--v-data-table :headers="studentHeaders" :items="studentBySearch"
                                                              :rows-per-page-items="rowsPerPageItems"
                                                              :pagination.sync="pagination"
                                                              class="elevation-1 gru-table fixed-header">
                                                    <template slot="items" slot-scope="props">
                                                        <td class="text-xs-center">{{ props.index+1 }}</td>
                                                        <td class="text-xs-left">{{ props.item.fullName }}</td>
                                                        <td class="text-xs-left">{{ props.item.email }}</td>
                                                        <td class="text-xs-left">{{ props.item.phone }}</td>
                                                        <td class="justify-center">
                                                            <v-btn @click="selectStudent(props.item.email)"
                                                                   class="mx-0" icon>
                                                                <v-icon color="pink">note_add</v-icon>
                                                            </v-btn>
                                                        </td>
                                                    </template>
                                                </v-data-table-->
                                                <div class="tableHeader">Danh sách học viên được mời</div>
                                                <div style="max-height: 400px;overflow-y: auto">
                                                    <v-data-table :headers="selectStudentHeader"
                                                                  :items="lstSelectStudent"
                                                                  :rows-per-page-items="rowsPerPageItems"
                                                                  :pagination.sync="pagination"
                                                                  class="elevation-1 gru-table fixed-header">
                                                        <template slot="items" slot-scope="props">
                                                            <td class="text-xs-center">{{ props.index+1 }}</td>
                                                            <td class="text-xs-left">{{ props.item }}</td>
                                                            <td class="justify-center">
                                                                <v-btn @click="deleteSelectStudent(props.index)"
                                                                       class="mx-0" icon>
                                                                    <v-icon color="pink">delete</v-icon>
                                                                </v-btn>
                                                            </td>
                                                        </template>
                                                    </v-data-table>
                                                </div>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click.native="sClose" color="red" dark>Hủy</v-btn>
                                <v-btn @click.native="inviteStudent" class="yoprimary" dark v-if="showInvite">Mời
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog>
                        <add-student-component :classId="classId" :cl="cl" ref="addDialog"
                                               @close="refreshTabMembers"/>
                    </v-dialog>
                    <div class="tableHeader" style="text-align: left">Danh sách học viên</div>
                    <v-data-table :headers="studentHeaders" :items="students" class="elevation-1"
                                  :pagination.sync="pagination">
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-center">{{ props.index+1 + parseInt(pagination.page-1) *
                                parseInt(pagination.rowsPerPage)}}
                            </td>
                            <td class="text-xs-left">
                                <i-avatar :user-id="props.item.userId"/>
                                <label style="line-height: 35px">{{ props.item.fullName }}</label>
                            </td>
                            <td class="text-xs-left"
                                v-if="$store.state.auth.user.role == 4|| $store.state.auth.user.role == 1">{{
                                props.item.email }}
                            </td>
                            <td class="text-xs-left"
                                v-if="$store.state.auth.user.role == 4|| $store.state.auth.user.role == 1">{{
                                props.item.phone }}
                            </td>
                            <td class="text-xs-left"
                                v-if="$store.state.auth.user.role == 4|| $store.state.auth.user.role == 1">
                                <label v-if="props.item.status==0" style="color:red">Chờ duyệt</label>
                                <label v-else-if="props.item.status==1">Đã duyệt</label>
                            </td>
                            <td class="justify-center layout px-0">
                                <v-btn @click="viewMember(props.item,'student')" class="mx-0" icon
                                       v-if="$store.state.auth.user.role == 4|| $store.state.auth.user.role == 1|| $store.state.auth.user.userId== props.item.userId">
                                    <v-icon color="primary">visibility</v-icon>
                                </v-btn>
                                <v-btn @click="deleteMember(props.item)" class="mx-0" icon
                                       v-if="$store.state.auth.user.role == 4|| $store.state.auth.user.role == 1">
                                    <v-icon color="pink">delete</v-icon>
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>
                    <div></div>
                </div>
                <v-dialog key="waitAllow" width="800px" v-model="approveDialog" persistent>
                    <v-card>
                        <v-card-title>
                            <div class="headline dialog-header">
                                <v-btn @click="approveDialog=false" icon style="float: left">
                                    <v-icon>close</v-icon>
                                </v-btn>
                                Duyệt học viên vào lớp
                            </div>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table :headers="studentHeaders" :items="studentWaiting"
                                          class="elevation-1">
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-center">{{ props.index+1}}</td>
                                    <td class="text-xs-left">{{ props.item.fullName }}</td>
                                    <td class="text-xs-left">{{ props.item.email }}</td>
                                    <td class="text-xs-left">{{ props.item.phone }}</td>
                                    <td class="text-xs-left">
                                        <div v-if="props.item.status==0" style="color:red;">Chờ phê duyệt</div>
                                        <div v-else-if="props.item.status==1">Đã duyệt</div>
                                    </td>
                                    <td class="text-xs-left">
                                        <div>
                                            Duyệt vào lớp
                                            <input :key="props.item.classMemberId" class="tableInput"
                                                   type="checkbox"
                                                   v-model="props.item.selected"/>
                                        </div>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn color="primary" @click="approveStudents">Duyệt vào lớp</v-btn>
                        </v-card-actions>
                    </v-card>

                </v-dialog>
            </div>
            <div v-else class="yocontent">
                <member-detail :editing-member="editingMember" :user="editingUser" :view-type="viewType"
                               @cancel="showList=true"/>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
    import axios from "axios";
    import {CrudService} from "@/services";
    import {message} from "@/shared/message";
    import {Validator, ValidationObserver} from "vee-validate";
    import MemberDetail from "./memberDetail";
    import AddStudentComponent from "../home/AddStudentComponent";

    export default {
        name: "invite-page",

        components: {
            AddStudentComponent,
            MemberDetail,
            ValidationObserver
        },
        props: {
            classId: {
                type: String | Number,
                default: null
            },
            cl: {
                type: Object,
                default: null
            },
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            },
        },

        data: () => ({
            tDialog: false,
            cDialog: false,
            sDialog: false,
            approveDialog: false,
            showInvite: false,
            showList: true,
            editingMember: null,
            editingUser: null,
            teacherForm: false,
            studentForm: false,
            viewType: "student",
            teacherHeaders: [
                {
                    text: "Giáo viên",
                    align: "left",
                    sortable: false,
                    value: "name"
                },
                {
                    text: "Email",
                    align: "left",
                    sortable: false,
                    value: "email"
                },
                {
                    text: "Số điện thoại",
                    align: "left",
                    sortable: false,
                    value: "phone"
                },
                {text: "Xử lý", value: "name", align: "center", sortable: false}
            ],
            studentHeaders: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    value: "userId"
                },
                {
                    text: "Học viên",
                    align: "left",
                    sortable: false,
                    value: "name"
                },
                {
                    text: "Email",
                    align: "left",
                    sortable: false,
                    value: "email"
                },
                {
                    text: "Số điện thoại",
                    align: "left",
                    sortable: false,
                    value: "phone"
                },
                {
                    text: "Trạng thái",
                    align: "left",
                    sortable: false,
                    value: "status"
                },
                {text: "Xử lý", value: "name", align: "center", sortable: false}
            ],
            selectStudentHeader: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    value: "userId",
                    width: "10%"
                },
                {
                    text: "Email",
                    align: "left",
                    sortable: false,
                    value: "email",
                    width: "80%"
                },
                {text: "Xóa", value: "name", align: "center", sortable: false, width: "10%"}
            ],
            lstSelectStudent: [],
            teachers: [],
            students: [],
            lstInviteStudent: [],
            teacherBySearch: [],
            studentBySearch: [],
            studentWaiting: [],
            student: {
                fullName: ""
            },
            teacher: {
                fullName: ""
            },
            tEmails: "",
            sEmails: "",
            defaultItem: {
                fullName: ""
            },
            pagination: {
                rowsPerPage: 5,
                page: 1,
                totalItems: 0,
            },

        }),

        computed: {},

        watch: {
            dialog(val) {
                val || this.close();
            },

            sDialog(val) {
                this.sEmails = "";
                this.showInvite = false;
                this.lstSelectStudent = [];
                this.$validator.reset();
            }
        },

        mounted() {
            Validator.extend("multiEmail", {
                validate: (value) => {
                    console.log("--- multi email check ---");
                    if (value.trim().lenght == 0) {
                        return true;
                    }
                    let emails = value.split(",");
                    let re = /\S+@\S+\.\S+/;
                    for (let i = 0; i < emails.length; i++) {
                        if (!re.test(emails[i])) {
                            console.log("--- multi email check  false---");
                            return false;
                        }
                    }
                    console.log("--- multi email check true---");
                    return true;
                },
                getMessage: (field, params, data) => {
                    return "Không đúng định dạng email";
                }
            });

        },

        created() {
            if (this.$store.state.auth.user.role == 1 || this.$store.state.auth.user.role == 4) {
                this.studentHeaders = [
                    {
                        text: "STT",
                        align: "center",
                        sortable: false,
                        value: "userId"
                    },
                    {
                        text: "Học viên",
                        align: "left",
                        sortable: false,
                        value: "name"
                    },
                    {
                        text: "Email",
                        align: "left",
                        sortable: false,
                        value: "email"
                    },
                    {
                        text: "Số điện thoại",
                        align: "left",
                        sortable: false,
                        value: "phone"
                    },
                    {
                        text: "Trạng thái",
                        align: "left",
                        sortable: false,
                        value: "status"
                    },
                    {text: "Xử lý", value: "name", align: "center", sortable: false}
                ]
            } else {
                this.studentHeaders = [
                    {
                        text: "STT",
                        align: "center",
                        sortable: false,
                        value: "userId"
                    },
                    {
                        text: "Học viên",
                        align: "left",
                        sortable: false,
                        value: "name"
                    },
                    {text: "Xử lý", value: "name", align: "center", sortable: false}
                ];

                this.teacherHeaders = [
                    {
                        text: "Giáo viên",
                        align: "left",
                        sortable: false,
                        value: "name"
                    },
                    {
                        text: "Email",
                        align: "left",
                        sortable: false,
                        value: "email"
                    },
                    {
                        text: "Số điện thoại",
                        align: "left",
                        sortable: false,
                        value: "phone"
                    }
                ];

            }

            //this.refreshTabMembers();
        },
        methods: {
            deleteMember(member) {
                if (this.$store.state.auth.user.role != 4) {
                    message.error("Chức năng dành riêng cho giáo viên giảng dạy");
                    return;
                }
                if (confirm("Bạn có chắc muốn xóa thành viên của lớp?")) {
                    axios
                        .post(process.env.VUE_APP_API_URL + "/classmember/deleteMember?classId=" + this.classId + "&classMemberId=" + member.classMemberId)
                        .then(
                            () => {
                                message.success(this.$t("lang.common.delete_success"));
                                this.refreshTabMembers();
                            },
                            error => {
                                message.error(error);
                            }
                        );
                }
            },

            viewMember(member, viewType) {
                //console.log(viewType);
                this.viewType = viewType;
                CrudService.of('user').getItem(member.userId).then(user => {
                    this.editingMember = member;
                    this.editingUser = user;
                    this.showList = false;
                });
                //console.log(member);
                //this.editingMember = member;
            },

            saveMemberProfile: function () {
                axios.post(process.env.VUE_APP_API_URL + "/classmember/updateNotify", this.editingMember).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t('lang.common.save_success'));
                        } else {
                            message.error(data.description);
                        }
                    },
                    error => {
                        message.error(error);
                    }
                )
            },

            close() {
                this.dialog = false;
            },

            selectTeacher: function (email) {
                if (this.tEmails == null) {
                    this.tEmails = email;
                } else {
                    this.tEmails += "," + email;
                }
            },

            selectStudent: function (email) {

                this.lstSelectStudent.push(email);
                /*
                                if (this.sEmails == null || this.sEmails == "") {
                                    this.sEmails = email;
                                } else {
                                    this.sEmails += "," + email;
                                }
                */
            },

            inviteStudent() {
                if (this.lstSelectStudent.length == 0) {
                    message.error("Bạn chưa nhập email học sinh");
                    return;
                }
                let email = this.lstSelectStudent[0];
                for (let i = 1; i < this.lstSelectStudent.length; i++) {
                    email += "," + this.lstSelectStudent[i];
                }
                let url = process.env.VUE_APP_API_URL + "/classmember/inviteStudent?classId=" + this.classId + "&listEmail=" + email;
                axios
                    .post(url)
                    .then(
                        data => {
                            if (data.success) {
                                message.success(this.$t("lang.common.save_success"));
                                this.sEmails = "";
                                this.sClose();
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },

            inviteTeacher() {
                if (!this.teacherForm) {
                    message.error("Bạn chưa nhập email hoặc email không đúng định dạng");
                    return;
                }
                let url = process.env.VUE_APP_API_URL + "/classmember/inviteTeachers?classId=" + this.classId + "&listEmail=" + this.tEmails;
                axios
                    .post(url)
                    .then(
                        data => {
                            if (data.success) {
                                message.success(this.$t("lang.common.save_success"));
                                this.tEmails = "";
                                this.tClose();
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    );

            },

            addNewStudent() {
                if (this.$store.state.auth.user.role != 4) {
                    message.error("Chức năng dành riêng cho giáo viên giảng dạy");
                    return;
                }
                this.cDialog = true;
            },

            insertNewStudent() {
                this.$refs.addDialog.show();
            },

            refreshTabMembers: function () {
                axios
                    .post(process.env.VUE_APP_API_URL + "/classmember/myTeachers?classId=" + this.classId)
                    .then(
                        data => {
                            this.teachers = data;
                        },
                        error => {
                        }
                    ),
                    axios
                        .post(process.env.VUE_APP_API_URL + "/classmember/allStudents?classId=" + this.classId)
                        .then(
                            data => {
                                this.students = data;
                            },
                            error => {
                            }
                        );
            },

            refreshTabWaitAllow: function () {
                axios
                    .post(process.env.VUE_APP_API_URL + "/classmember/waitingStudent?classId=" + this.classId)
                    .then(
                        data => {
                            this.studentWaiting = data;
                        },
                        error => {
                        }
                    );
            },

            rejectStudent: function (classMemberId) {
                if (this.$store.state.auth.user.role != 4) {
                    message.error("Chức năng dành riêng cho giáo viên giảng dạy");
                    return;
                }
                if (confirm("Bạn có chắc muốn từ chối học viên?")) {
                    axios
                        .post(process.env.VUE_APP_API_URL + "/classmember/rejectRequest?classId=" + this.classId + "&classMemberId=" + classMemberId)
                        .then(
                            () => {
                                message.success(this.$t("lang.common.update_success"));
                                this.refreshTabMembers();
                                this.refreshTabWaitAllow();
                            },
                            error => {
                                message.error(error);
                            }
                        );
                }
            },

            acceptStudent: function (userId) {
                if (this.$store.state.auth.user.role != 4) {
                    message.error("Chức năng dành riêng cho giáo viên giảng dạy");
                    return;
                }
                if (confirm("Bạn có chắc muốn chấp nhận thành viên của lớp?")) {
                    axios
                        .post(process.env.VUE_APP_API_URL + "/classmember/acceptStudent?classId=" + this.classId + "&userId=" + userId)
                        .then(
                            () => {
                                message.success(this.$t("lang.common.update_success"));
                                this.refreshTabMembers();
                                this.refreshTabWaitAllow();
                            },
                            error => {
                                message.error(error);
                            }
                        );
                }

            },

            searchTeacher: function () {
                let search = {
                    'role': 1,
                    'email': this.tEmails
                }
                axios.post(process.env.VUE_APP_API_URL + "/user/search", search).then(
                    data => {
                        this.teacherBySearch = data.items;
                    },
                    error => {
                        message.error(data);
                    }
                )
            },

            searchStudent: function () {
                let search = {
                    'role': 2,
                    'email': this.sEmails
                }
                axios.post(process.env.VUE_APP_API_URL + "/user/search", search).then(
                    data => {
                        this.studentBySearch = data.items;
                    },
                    error => {
                        message.error(data);
                    }
                )

            },

            addInviteStudent: function () {
                if (!this.studentForm) {
                    message.error("Bạn chưa nhập email hoặc email không đúng định dạng");
                    return;
                }
                let mails = this.sEmails.split(",");
                for (let i = 0; i < mails.length; i++) {
                    let add = true;
                    for (let j = 0; j < this.lstSelectStudent.length; j++) {
                        if (mails[i] == this.lstSelectStudent[j]) {
                            add = false;
                            break;
                        }
                    }
                    if (add) {
                        this.lstSelectStudent.push(mails[i]);
                    }
                }
                this.sEmails = "";
                this.$validator.reset();
            },

            onApprove() {
                if (this.$store.state.auth.user.role != 4) {
                    message.error("Chức năng dành riêng cho giáo viên giảng dạy");
                    return;
                }
                this.approveDialog = true;
                this.refreshTabWaitAllow();
            },

            approveStudents() {
                if (confirm("Bạn có chắc muốn phê duyệt yêu cầu gia nhập lớp?")) {
                    let lstAccept = [];
                    for (let i = 0; i < this.studentWaiting.length; i++) {
                        if (this.studentWaiting[i].selected) {
                            lstAccept.push(this.studentWaiting[i]);
                        }
                    }
                    if (lstAccept.length == 0) {
                        message.error("Bạn chưa chọn học viên để phê duyệt");
                        return;
                    }
                    axios
                        .post(process.env.VUE_APP_API_URL + "/classmember/acceptMultiStudent?classId=" + this.classId, lstAccept)
                        .then(
                            () => {
                                message.success(this.$t("lang.common.update_success"));
                                this.refreshTabMembers();
                                this.refreshTabWaitAllow();
                                this.approveDialog = false;
                            },
                            error => {
                                message.error(error);
                            }
                        );
                }

            },

            deleteSelectStudent(index) {
                this.lstSelectStudent.splice(index, 1);
            },

            tClose() {
                this.tDialog = false;
                setTimeout(() => {
                }, 300);
            },

            sClose() {
                this.sDialog = false;
                setTimeout(() => {
                }, 300);
            },

            copyCode() {
                //console.log(this.cl.classCode);
                //document.execCommand("copy", this.cl.classCode);
                navigator.clipboard.writeText(this.cl.classCode).then(
                    function () {
                        console.log("copy success");
                    },
                    function () {
                        console.log("copy error");
                    }
                );
                message.success("Đã copy mã lớp vào bộ clipboard");
            }
        },

    };
</script>